// utils/formatting.js

/**
 * Formats a value as currency with no decimals if it's not a large number.
 */
export const formatCurrency = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return '$0';
    const absValue = Math.abs(value);
    const formattedValue =
        absValue >= 1000000
            ? `$${(absValue / 1000000).toFixed(1)}m`
            : absValue >= 1000
                ? `$${(absValue / 1000).toFixed(0)}k`
                : `$${absValue.toFixed(0)}`;
    return value < 0 ? `-${formattedValue}` : formattedValue;
};

/**
 * Formats a value as currency with one decimal place.
 */
export const formatCurrencyDecimal = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return '$0';
    const absValue = Math.abs(value);
    const formattedValue =
        absValue >= 1000000
            ? `$${(absValue / 1000000).toFixed(1)}m`
            : absValue >= 1000
                ? `$${(absValue / 1000).toFixed(1)}k`
                : `$${absValue.toFixed(0)}`;
    return value < 0 ? `-${formattedValue}` : formattedValue;
};

/**
 * Formats a value as standard U.S. dollars with commas and no decimal places.
 */
export const formatCurrencyDollars = (value) => {
    if (typeof value !== 'number' || isNaN(value)) return '$0';

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
    });

    return formatter.format(value);
};
